import React, { Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import AdicionaTipoOcorrencia from "./pages/escalas/tipoOcorrencia/Adiciona";
import lancarOcorrencias from "./pages/movimentacoes/lancarOcorrencias";
// import AuthRoute from '../utils/AuthRoute'

import Spinner from "./pages/shared/Spinner";

const Dashboard = lazy(() => import("./pages/dashboard"));
const Dashboard2 = lazy(() => import("./pages/dashboard/Dashboard"));
const Buttons = lazy(() => import("./pages/basic-ui/Buttons"));
const Dropdowns = lazy(() => import("./pages/basic-ui/Dropdowns"));
const Typography = lazy(() => import("./pages/basic-ui/Typography"));
const BasicElements = lazy(() => import("./pages/form-elements/BasicElements"));
const BasicTable = lazy(() => import("./pages/tables/BasicTable"));
const FontAwesome = lazy(() => import("./pages/icons/FontAwesome"));
const ChartJs = lazy(() => import("./pages/charts/ChartJs"));
const Error404 = lazy(() => import("./pages/user-pages/Error404"));
const Error500 = lazy(() => import("./pages/user-pages/Error500"));
const Login = lazy(() => import("./pages/user-pages/Login"));
const Register1 = lazy(() => import("./pages/user-pages/Register"));
const BlankPage = lazy(() => import("./pages/user-pages/BlankPage"));
const Perfil = lazy(() => import("./pages/usuario/Perfil"));
const Teste = lazy(() => import("./pages/dashboard/teste"));

//PHOPONTO PAGINAS
// Cadastro
const Empresas = lazy(() => import("./pages/cadastros/empresa"));
const Funcionario = lazy(() => import('./pages/cadastros/funcionarios'));
const Adicionar_Funcionario = lazy(() => import("./pages/cadastros/funcionarios/adicionar_funcionario"));
const EditarFuncionario = lazy(() => import("./pages/cadastros/funcionarios/EditarFuncionario"));
const AdicionaEmpresa = lazy(() =>import("./pages/cadastros/empresa/AdicionaEmpresa"));
const EditarEmpresa = lazy(() =>import("./pages/cadastros/empresa/EditarEmpresa"));
const Unidades = lazy(() => import("./pages/cadastros/unidade"));
const AdicionaUnidade = lazy(() =>import("./pages/cadastros/unidade/AdicionaUnidade"));
const EditarUnidade = lazy(() =>import("./pages/cadastros/unidade/EditarUnidade"));
const Setores = lazy(() => import("./pages/cadastros/setor"));
const AdicionarSetor = lazy(() =>import("./pages/cadastros/setor/AdicionarSetor"));
const EditarSetor = lazy(() =>import("./pages/cadastros/setor/EditarSetor"));
const Cargos = lazy(() => import("./pages/cadastros/cargo"));
const AdicionaCargo = lazy(() =>import("./pages/cadastros/cargo/AdicionaCargo"));
const EditarCargo = lazy(() =>import("./pages/cadastros/cargo/EditarCargo"));
const Sindicatos = lazy(() => import("./pages/cadastros/sindicato"));
const AdicionaSindicato = lazy(() =>import("./pages/cadastros/sindicato/AdicionaSindicato"));
const EditarSindicato = lazy(() => import("./pages/cadastros/sindicato/EditarSindicato"));
const TiposUsuarioos = lazy(() => import("./pages/cadastros/tiposUsuarios"))
const Adicionar_tipoUsuario = lazy(() => import("./pages/cadastros/tiposUsuarios/adicionar_tipoUsuario"))
const Usuarios = lazy(()=>import("./pages/cadastros/usuarios"))
const adicionar_Usuarios = lazy(() => import("./pages/cadastros/usuarios/AdicionaUsuario"))
const EditarUsuario = lazy(()=>import("./pages/cadastros/usuarios/EditarUsuario"))
const Alterar_tipousuario = lazy(() => import("./pages/cadastros/tiposUsuarios/alterar_tipoUsuario"))
const Layouts = lazy(()=>import("./pages/cadastros/layout"));
const AdicionaLayout = lazy(()=>import("./pages/cadastros/layout/AdicionaLayout"));
const EditarLayout = lazy(()=>import("./pages/cadastros/layout/EditarLayout"));
//Fim - Cadastro

// Escalas
const TipoOcorrencia = lazy(() => import('./pages/escalas/tipoOcorrencia'))
const EditarTipoOcorrencia = lazy(() => import('./pages/escalas/tipoOcorrencia/Editar'))
const Feriados = lazy(() => import('./pages/escalas/feriado'))
const AdicionaFeriado = lazy(() => import('./pages/escalas/feriado/AdicionaFeriado'))
const EditarFeriado = lazy(() => import('./pages/escalas/feriado/EditarFeriado'))
const Horarios = lazy(() => import('./pages/escalas/horarios'))
const AdicionaHorario = lazy(() => import('./pages/escalas/horarios/AdicionarHorario'))
const EditarHorario = lazy(() => import('./pages/escalas/horarios/EditarHorario'))
const Semanal = lazy(() => import('./pages/escalas/semanal'))
const adicionarSemanal = lazy(() => import('./pages/escalas/semanal/adicionarSemanal'))
const EditarSemanal = lazy(() => import('./pages/escalas/semanal/EditarSemanal'))
const Especial = lazy(() => import('./pages/escalas/especial'))
const adicionarEspecial = lazy(() => import('./pages/escalas/especial/adicionarEspecial'))
const funcionarioXescala = lazy(() => import('./pages/escalas/funcionarioXescala'))
const AlterarEspecial = lazy(() => import('./pages/escalas/especial/alterarEspecial'))
//Escala - FIM

//Inicio_Movimentações
const FolhaDePagamento = lazy(() => import('./pages/movimentacoes/folhaDePagamento'))
const LancarOcorrencias = lazy(() => import('./pages/movimentacoes/lancarOcorrencias'))
const importaAFD = lazy(() => import('./pages/movimentacoes/importaAFD'))
const ArquivosAFDT = lazy(() => import('./pages/movimentacoes/arquivosAFDT'))
const ArquivosACJEF = lazy(() => import('./pages/movimentacoes/arquivosACJEF'))
const VisualizarMarcacoes = lazy(() => import('./pages/movimentacoes/visualizarMarcacoes'))
const processarPonto = lazy(() => import('./pages/movimentacoes/processarPonto'))
const limparBH = lazy(() => import('./pages/movimentacoes/limparBH'))
const saldoExcedenteBH = lazy(() => import('./pages/movimentacoes/saldoExcedenteBH'))
const marcacoesSolicitadas = lazy(() => import('./pages/movimentacoes/processarPonto/marcacoesSolicitadas'))
const ponto = lazy(() => import('./pages/movimentacoes/processarPonto/ponto'))
//Fim_Movimentações


//Inicio_Ferramentas
const NotificacaoPush = lazy(() => import('./pages/ferramentas/notificacao'))
const CriarNotificacao = lazy(() => import('./pages/ferramentas/notificacao/CriarNotificacao'))
const Auditoria = lazy(() => import('./pages/ferramentas/auditoria'))
const IfvArquivoTexto = lazy(() => import('./pages/ferramentas/ifvArquivoTexto'))
const GaFiscais = lazy(() => import('./pages/ferramentas/gaFiscais'))
const CeFolhaPagamento = lazy(() => import('./pages/ferramentas/ceFolhaPagamento'))
const Incluir_CeFolhaPagamento = lazy(() => import('./pages/ferramentas/ceFolhaPagamento/incluir_ceFolhaPagamento'))
const Editar_CeFolhaPagamento = lazy(() => import('./pages/ferramentas/ceFolhaPagamento/editar_ceFolhaPagamento'))
//Fim_Ferramentas


//Inicio_Relatorio
const BancoHoras = lazy(() => import('./pages/relatorios/bancoHoras'))
const MarcacoesOriginais = lazy(() => import('./pages/relatorios/marcacoesOriginais'))
const ValesTransportes = lazy(() => import('./pages/relatorios/valesTransportes'))
const AdicionalNoturno = lazy(() => import('./pages/relatorios/adicionalNoturno'))
const EscalaSemanaXHorarios = lazy(() => import('./pages/relatorios/escalaSemanaXHorarios'))
const FuncionariosAIA = lazy(() => import('./pages/relatorios/funcionariosAIA'))
const Absenteismo = lazy(() => import('./pages/relatorios/absenteismo'))
//Fim_Relatorio


//Incio_Configurações
const Configuracoes_info = lazy(() => import('./pages/configuracoes/configuracoes_info'))
const AlterarSenha = lazy(() => import('./pages/configuracoes/alterarSenha'))
//Fim_Configurações
export default function AppRoutes() {
  return (
    <Suspense fallback={<Spinner />}>
      <Switch>
        {/*Inicio - ROUTE Cadastro */}
        <Route exact path="/dashboard/cadastro/empresas" component={Empresas} />
        <Route exact path="/dashboard/cadastro/empresa/adiciona" component={AdicionaEmpresa} />
        <Route exact path="/dashboard/cadastro/empresa/editar/:idEmpresa" component={EditarEmpresa} />
        <Route exact path="/dashboard/cadastro/funcionarios" component={Funcionario}/>
        <Route exact path="/dashboard/cadastro/funcionario/adicionar" component={Adicionar_Funcionario}/>
        <Route exact path="/dashboard/cadastro/funcionario/editar/:idPessoa" component={EditarFuncionario}/>
        <Route exact path="/dashboard/cadastro/unidades" component={Unidades} />
        <Route exact path="/dashboard/cadastro/unidade/adiciona" component={AdicionaUnidade} />
        <Route exact path="/dashboard/cadastro/unidade/editar/:idUnidade" component={EditarUnidade} />
        <Route exact path="/dashboard/cadastro/setores" component={Setores} />
        <Route exact path="/dashboard/cadastro/setor/adiciona" component={AdicionarSetor} />
        <Route exact path="/dashboard/cadastro/setor/editar/:idSetor" component={EditarSetor} />
        <Route exact path="/dashboard/cadastro/cargos" component={Cargos} />
        <Route exact path="/dashboard/cadastro/cargo/adiciona" component={AdicionaCargo} />
        <Route exact path="/dashboard/cadastro/cargo/editar/:idCargo" component={EditarCargo} />
        <Route exact path="/dashboard/cadastro/sindicatos" component={Sindicatos} />
        <Route exact path="/dashboard/cadastro/sindicato/adiciona" component={AdicionaSindicato} />
        <Route exact path="/dashboard/cadastro/sindicato/editar/:idSindicato" component={EditarSindicato} />
        {/* <Route exact path="/dashboard/cadastro/tiposUsuarios" component={TiposUsuarioos}/>        */}
        {/* <Route exact path="/dashboard/cadastro/tiposUsuarios/adicionar" component={Adicionar_tipoUsuario}/> */}
        <Route exact path="/dashboard/cadastro/usuarios" component={Usuarios}/>
        <Route exact path="/dashboard/cadastro/usuario/editar/:idUser" component={EditarUsuario}/>
        <Route exact path="/dashboard/cadastro/usuario/adicionar" component={adicionar_Usuarios}/>
        {/* <Route exact path="/dashboard/cadastro/tiposUsuarios/editar/:idTipoUsuario" component={Alterar_tipousuario}/> */}
        <Route exact path="/dashboard/cadastro/layouts" component={Layouts}/>
        <Route exact path="/dashboard/cadastro/layout/adiciona" component={AdicionaLayout}/>
        <Route exact path="/dashboard/cadastro/layout/editar/:idLayout" component={EditarLayout}/>

        {/*Fim - ROUTE Cadastro */}
        
        {/**TESTE */}
        <Route exact path="/dashboard/calculos" component={Teste}/>


        {/*Inicio - ROUTE Escala */}
        <Route exact path="/dashboard/escala/tipoOcorrencia" component={TipoOcorrencia} />
        <Route exact path="/dashboard/escala/tipoOcorrencia/adiciona" component={AdicionaTipoOcorrencia} />
        <Route exact path="/dashboard/escala/tipoOcorrencia/editar/:idTipoOcorrencia" component={EditarTipoOcorrencia} />
        <Route exact path="/dashboard/escala/feriados" component={Feriados} />
        <Route exact path="/dashboard/escala/feriado/adiciona" component={AdicionaFeriado} />
        <Route exact path="/dashboard/escala/feriado/editar/:idFeriado" component={EditarFeriado} />
        <Route exact path="/dashboard/escala/horarios" component={Horarios}></Route>
        <Route exact path="/dashboard/escala/horario/adiciona" component={AdicionaHorario} />
        <Route exact path="/dashboard/escala/horario/editar/:idHorario" component={EditarHorario}></Route>
        <Route exact path="/dashboard/escala/semanal" component={Semanal} />
        <Route exact path="/dashboard/escala/semanal/adiciona" component={adicionarSemanal} />
         <Route exact path="/dashboard/escala/semanal/editar/:idEscalaSemanal" component={EditarSemanal} />
        <Route exact path="/dashboard/escala/especial" component={Especial} />
        <Route exact path="/dashboard/escala/especial/adicionarEspecial" component={adicionarEspecial} />
        <Route exact path="/dashboard/escala/funcionarioXescala" component={funcionarioXescala} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/" component={Dashboard} />
        <Route exact path="/icons/font-awesome" component={Dashboard2} />
        <Route exact path="/dashboard/escala/especial/alterar/:idEscalaEspecial" component={AlterarEspecial}/>
        {/*Fim - ROUTE Escala */}


        {/*Inicio - Movimentações*/}
        <Route exact path="/dashboard/movimentacoes/lancarOcorrencias" component={LancarOcorrencias} />
        <Route exact path="/dashboard/movimentacoes/importAFD" component={importaAFD} />
        <Route exact path="/dashboard/movimentacoes/arquivos_AFDT" component={ArquivosAFDT} />
        <Route exact path="/dashboard/movimentacoes/arquivos_ACJEF" component={ArquivosACJEF} />
        <Route exact path="/dashboard/movimentacoes/visualizarMarcacoes" component={VisualizarMarcacoes} />
        <Route exact path="/dashboard/movimentacoes/processarPonto" component={processarPonto} />
        <Route exact path="/dashboard/movimentacoes/limparBH" component={limparBH} />
        <Route exact path="/dashboard/movimentacoes/saldoExcedenteBH" component={saldoExcedenteBH} />
        <Route exact path="/dashboard/movimentacoes/processarPonto/marcacoesSolicitadas" component={marcacoesSolicitadas}/>
        <Route exact path="/dashboard/movimentacoes/folhaDePagamento" component={FolhaDePagamento}/>
        <Route exact path="/dashboard/movimentacoes/processarPonto/ponto" component={ponto}/>
        {/*Fim - Movimentações*/}

        {/*Inicio - Ferramentas*/}
        <Route exact path="/dashboard/ferramentas/notificacao-push" component={NotificacaoPush} />
        <Route exact path="/dashboard/ferramentas/notificacao-push/criar" component={CriarNotificacao} />
        <Route exact path="/dashboard/ferramentas/auditoria" component={Auditoria} />
        <Route exact path="/dashboard/ferramentas/ifvArquivoTexto" component={IfvArquivoTexto} />
        <Route exact path="/dashboard/ferramentas/gaFiscais" component={GaFiscais} />
        <Route exact path="/dashboard/ferramentas/ceFolhaPagamento" component={CeFolhaPagamento} />
        <Route exact path="/dashboard/ferramentas/ceFolhaPagamento/incluir_ceFolhaPagamento" component={Incluir_CeFolhaPagamento} />
        <Route exact path="/dashboard/ferramentas/ceFolhaPagamento/editar_ceFolhaPagamento/:idIntegracaoFolha" component={Editar_CeFolhaPagamento} />

        {/*Fim - Ferramentas*/}
        <Route exact path="/basic-ui/buttons" component={Buttons} />
        <Route exact path="/basic-ui/dropdowns" component={Dropdowns} />
        <Route exact path="/basic-ui/typography" component={Typography} />


        {/*Inicio - Relatorios*/}
        <Route exact path="/dashboard/relatorios/bancoHoras" component={BancoHoras} />
        <Route exact path="/dashboard/relatorios/marcacoesOriginais" component={MarcacoesOriginais} />
        <Route exact path="/dashboard/relatorios/valesTransportes" component={ValesTransportes} />
        <Route exact path="/dashboard/relatorios/adicionalNoturno" component={AdicionalNoturno} />
        <Route exact path="/dashboard/relatorios/escalaSemanaXHorarios" component={EscalaSemanaXHorarios} />
        <Route exact path="/dashboard/relatorios/funcionariosAIA" component={FuncionariosAIA} />
        <Route exact path="/dashboard/relatorios/absenteismo" component={Absenteismo} />
        {/*Fim - Relatorios*/}


        {/*Inicio - Configurações*/}
        <Route exact path="/dashboard/configuracoes/configuracoes_info" component={Configuracoes_info} />
        <Route exact path="/dashboard/configuracoes/alterarSenha" component={AlterarSenha} />
        {/*Fim - Configurações*/}
        <Route
          exact
          path="/form-Elements/basic-elements"
          component={BasicElements}
        />

        <Route exact path="/tables/basic-table" component={BasicTable} />

        <Route exact path="/icons/font-awesome" component={FontAwesome} />

        <Route exact path="/charts/chart-js" component={ChartJs} />

        <Route exact path="/login" component={ Login }  />
        <Route exact path="/user-pages/register-1" component={ Register1 }/>

        <Route exact path="/user-pages/error-404" component={Error404} />
        <Route exact path="/user-pages/error-500" component={Error500} />

        <Route exact path="/user-pages/blank-page" component={BlankPage} />

        <Route exact path="/cliente/adiciona" component={BlankPage} />

        <Route exact path="/usuario/usuarios" component={BlankPage} />
        <Route exact path="/usuario/meu-perfil" component={BlankPage} />
        

      </Switch>
    </Suspense>
  );
}
